import { FC } from 'react'

import { getCategoryKeyFromRawCategory } from '../../../../../app/_components/pages/organization/constants'
import { useCart } from '../../../../../app/_providers/CartProvider.client'
import { useOrganization } from '../../../../../app/_providers/OrganizationProvider.client'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { CartEntry, hasPlaceholderLine, isLogoSetupInCart } from '../../utils'
import { EmbroideryGroupItem } from '../EmbroideryGroupItem/EmbroideryGroupItem'
import { EmbroideryGroupPlaceholder } from '../EmbroideryGroupItem/EmbroideryGroupPlaceholder'
import { CartLinePlaceholder } from '../RegularCartItem/CartLinePlaceholder'
import { RegularCartItem } from '../RegularCartItem/RegularCartItem'

interface Props {
  entry: CartEntry
  eventCategory: 'minicart' | 'cart'
  isBundleGroup?: boolean
}

export const CartEntryItem: FC<Props> = ({ entry, eventCategory, isBundleGroup }) => {
  const { status: cartStatus, updateItemsQuantity, removeItems, cart } = useCart()
  const { hasMandatoryEmbroidery } = useOrganization()
  const {
    cart: { embroideryItemLabel },
  } = useTranslation()

  const shouldRemoveRelatedPortalProduct =
    entry.embroidery !== undefined &&
    hasMandatoryEmbroidery({
      categoryId: entry.item.productType,
      categoryKey: getCategoryKeyFromRawCategory(entry.item.productType),
    })

  // Garment and embroidery switch together so a skeleton never sits beside a live, deletable panel
  const isPlaceholder = hasPlaceholderLine(entry)

  return (
    <>
      {isPlaceholder ? (
        <CartLinePlaceholder isBundleGroup={isBundleGroup} />
      ) : (
        <RegularCartItem
          cartIsUpdating={cartStatus === 'pending'}
          cartItem={entry.item}
          decrementQuantity={() => updateItemsQuantity([entry.item.key], -1)}
          eventCategory={eventCategory}
          incrementQuantity={() => updateItemsQuantity([entry.item.key], 1)}
          removeItem={() => removeItems([entry.item.key])}
          setQuantity={newQuantity => updateItemsQuantity([entry.item.key], () => newQuantity)}
          uniqueId={entry.item.key}
          isBundleGroup={isBundleGroup}
        />
      )}
      {entry.embroidery !== undefined && isPlaceholder ? (
        <EmbroideryGroupPlaceholder group={entry.embroidery} />
      ) : null}
      {entry.embroidery !== undefined && !isPlaceholder ? (
        <EmbroideryGroupItem
          group={entry.embroidery}
          removeGroup={() =>
            removeItems([entry.embroidery!.lines[0]!.key], {
              removeAssociatedPortalProduct: shouldRemoveRelatedPortalProduct,
            })
          }
          label={embroideryItemLabel}
          isLogoSetupInCart={isLogoSetupInCart(Object.values(cart.items))}
        />
      ) : null}
    </>
  )
}
